import React from "react";

const AssignedRnForm = ({ formData, handleChange }) => {

    const renderRow = (name, label, type = "INJECTION") => (
        <div className="col-md-6 mb-3 d-flex justify-content-center" key={name}>
            <div className="w-100 rounded-3 p-3 bg-light-subtle text-center">

                <div className="fw-semibold text-dark mb-2">{label}</div>

                {/* YES / NO */}
                <div className="d-flex justify-content-center mb-2">
                    {["Yes", "No"].map((option) => {
                        const id = `${name}-${option}`;
                        return (
                            <div className="form-check form-check-inline" key={option}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id={id}
                                    name={name}
                                    value={option}
                                    checked={formData[name] === option}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor={id}>
                                    {option}
                                </label>
                            </div>
                        );
                    })}
                </div>

                {/* If Yes → Show Dose + Type */}
                {formData[name] === "Yes" && (
                    <div className="row g-2 justify-content-center">

                        <div className="col-md-6">
                            <div className="form-floating form-floating-outline">
                                <input
                                    type="text"
                                    className="form-control"
                                    name={`${name}Dose`}
                                    value={formData[`${name}Dose`] || ""}
                                    onChange={handleChange}
                                    placeholder="Dose"
                                />
                                <label>Dose</label>
                            </div>
                        </div>

                        {/* Tablet → ORAL */}
                        {type === "TABLET" && (
                            <div className="col-md-12">
                                <small className="fw-semibold text-primary">ORAL</small>
                            </div>
                        )}

                        {/* Injections → IV / IM */}
                        {type === "INJECTION" && (
                            <div className="col-md-12">
                                {["IV", "IM"].map((t) => {
                                    const id = `${name}${t}`;
                                    return (
                                        <div className="form-check form-check-inline" key={t}>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                id={id}
                                                name={`${name}Type`}
                                                value={t}
                                                checked={formData[`${name}Type`] === t}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor={id}>
                                                {t}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );

    return (
        <>
            <div className="col-md-12 mb-3 text-center">
                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-inline-block px-3">
                    Injections / Tablets (To be filled by Assigned RN / A.N)
                </small>
            </div>

            <div className="row">
                {renderRow("rnQuetiapine", "Tab Quetiapine", "TABLET")}
                {renderRow("rnSerenace", "Inj Serenace", "INJECTION")}
                {renderRow("rnAvil", "Inj Avil", "INJECTION")}
                {renderRow("rnClopixol", "Inj Clopixol Accuphase/Depot", "INJECTION")}
                {renderRow("rnDormicum", "Inj Dormicum", "INJECTION")}
                {renderRow("rnVallium", "Inj Vallium", "INJECTION")}
                {renderRow("rnProcyclidine", "Tab Procyclidine", "TABLET")}
            </div>

            {/* RN Remarks */}
            <div className="col-md-12 mt-3">
                <div className="form-floating form-floating-outline">
                    <textarea
                        className="form-control"
                        name="rnRemarks"
                        value={formData.rnRemarks || ""}
                        onChange={handleChange}
                        placeholder="Remarks"
                        style={{ height: "100px" }}
                    />
                    <label>Remarks</label>
                </div>
            </div>

            {/* RN Identity */}
            <div className="col-md-12 mt-4">
                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                    Assigned RN / Dispenser
                </small>
            </div>

            <div className="row">
                <div className="col-md-4">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="rnName"
                            value={formData.rnName || ""}
                            onChange={handleChange}
                            placeholder="Name"
                        />
                        <label>Name</label>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="form-floating form-floating-outline mb-3">
                        <select
                            className="form-select"
                            name="rnDesignation"
                            value={formData.rnDesignation || ""}
                            onChange={handleChange}
                        >
                            <option value="">Select Designation</option>
                            <option value="Registered Nurse">Registered Nurse</option>
                            <option value="Dispenser">Dispenser</option>
                        </select>
                        <label>Designation</label>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="rnPlace"
                            value={formData.rnPlace || ""}
                            onChange={handleChange}
                            placeholder="Place of Administration"
                        />
                        <label>Place of Administration</label>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AssignedRnForm;
